export const CLIENT_ID = 'a1e2eb6c6c4982829e93'
export const CLIENT_SECRET = '7997e9cb7d1a232521fb414d4f503d3d685036bf'